import { render, staticRenderFns } from "./epb-select-dropdown-option.component.vue?vue&type=template&id=24a5eb0c&scoped=true"
import script from "./epb-select-dropdown-option.component.vue?vue&type=script&lang=ts"
export * from "./epb-select-dropdown-option.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-select-dropdown-option.component.vue?vue&type=style&index=0&id=24a5eb0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a5eb0c",
  null
  
)

export default component.exports